import React from "react";

import IconSelectField from "../../../shared/components/selectField/IconSelectField";
import { PRODUCT_TYPES_ENUMS } from "../../../system/globalEnums";
import { getCustomTypesOptionList } from "../../../shared/utility";
import { EMPTY_STRING, globalConstants } from "../../../constants";

const CustomItemProductTypeSelectField = ({
  setFieldValue,
  customTypes,
  isDisabled = false,
  ...props
}) => {
  const handleTypeChange = (option, setFieldValue) => {
    setFieldValue("productType", option.value);
    setFieldValue("category_name", EMPTY_STRING);
    setFieldValue("condition", EMPTY_STRING);
    setFieldValue("subcategory", EMPTY_STRING);
  };

  return (
    <IconSelectField
      label="Type"
      options={getCustomTypesOptionList(customTypes).filter(
        (item) => item.label !== PRODUCT_TYPES_ENUMS.ALL
      )}
      placeHolder="Type..."
      name="productType"
      customOnChange={(option) => handleTypeChange(option, setFieldValue)}
      isClearable={false}
      isDisabled={isDisabled}
    />
  );
};

export default CustomItemProductTypeSelectField;
